"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_pickby_1 = __importDefault(require("lodash.pickby"));

function pickBy(obj, predicate) {
  return lodash_pickby_1.default(obj, predicate);
}

exports.pickBy = pickBy;